import { Comments } from "../../../../../types/empresa";
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';

interface Props {
    comm: Comments;
}

export function ComentarioCard({ comm }: Props) {
    return (
        <div className="my-3 p-2 bg-slate-100 rounded shadow-sm">
            <div className="flex gap-x-1 items-center">
                <div className="w-[15px] h-[15px] rounded-full bg-green-800"></div>
                <p className="font-semibold">{comm.nombreCreador}</p>
            </div>
            <div className="my-1">
                <div className="flex gap-x-2">
                    <p className="font-semibold">Motivo: </p>
                    <p>{comm.motivo}</p>
                </div>
                <div>
                    <p>
                        <span className="font-semibold">Comentario: </span>
                        {comm.comentario}
                    </p>
                </div>
            </div>
            <div className="flex gap-x-2">
                <p className="text-sm">{comm.fecha}</p>
                <div className="border-l border-l-gray-400"></div>
                <div className="flex gap-x-1">
                    <p className="text-sm">{comm.anteriorEtapa}</p>
                    <ArrowForwardRoundedIcon sx={{ height: 20, width: 20 }}/>
                    <p className="text-sm">{comm.nuevaEtapa}</p>
                </div>
            </div>
        </div>
    );
}
